import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { CommonService } from '@services/common.service';
import { finalize } from 'rxjs';
let requestCount = 0;
const notificationUnreadUrl = 'api/PushNotification/UnreadCount';
const translationAssetPath = '/assets/i18n/';
export const httpLoaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.includes(translationAssetPath) ||
    req.url.includes('assets/i18n/')
  ) {
    return next(req);
  }

  const commonService = inject(CommonService);
  const isNotifUnreadUrl = req.url.indexOf(notificationUnreadUrl) !== -1;

  if (!isNotifUnreadUrl && requestCount === 0) {
    commonService.startLoader();
  }
  if (!isNotifUnreadUrl) {
    requestCount++;
  }
  return next(req).pipe(
    finalize(() => {
      if (!isNotifUnreadUrl) {
        requestCount--;
        if (requestCount === 0) {
          commonService.stopLoader();
        }
      }
    }),
  );
};
